// ======================================================================
// File Name       : index
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import ReactDOM from 'react-dom';
import 'whatwg-fetch';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'resize-observer-polyfill/dist/ResizeObserver.global';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-datetime/css/react-datetime.css';
import Root from './components/Root';
import store from './store';
import registerServiceWorker from './registerServiceWorker';
import './styles/index.css';

ReactDOM.render(<Root store={store} />, document.getElementById('root'));
registerServiceWorker();
